<template>
  <section class="section">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <h1 class="title">
      <a @click="$router.go(-1)">
        <b-icon icon="arrow-left" />
      </a>
      {{ $t('Nueva solicitud') }}
    </h1>
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <section class="hero">
          <div class="hero-body">
            <div class="container"></div>
          </div>
        </section>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
            <b-field grouped>
              <b-field expanded :label="$t('Email solicitante')">
                <ValidationProvider
                  name="Email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="email"
                    expanded
                    icon="email"
                    type="email"
                    placeholder="Email..."
                  ></b-input>

                  <p v-show="errors.length" class="help is-danger">
                    {{ $t('Email no válido') }}
                  </p>
                </ValidationProvider>
              </b-field>
              <b-field :label="$t('Idioma')">
                <b-select :value="language">
                  <option key="es" value="es">ES</option>
                  <option key="en" value="en">EN</option>
                </b-select>
              </b-field>
            </b-field>
            <div class="buttons">
              <button type="submit" class="button is-primary">
                {{ $t('Enviar nueva solicitud') }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </section>
</template>

<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

import Fetcher from '@/mixins/fetcher'
import { mapActions } from 'vuex'

extend('required', {
  ...required
})

extend('email', {
  ...email
})

export default {
  mixins: [Fetcher],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: function() {
    return {
      email: null,
      language: this.$i18n.locale
    }
  },
  methods: {
    ...mapActions('onBoard', ['postNewOnboardInviteRequest']),
    validateBeforeSubmit() {
      let self = this

      self.request(() =>
        self
          .postNewOnboardInviteRequest({
            email: self.email,
            language: self.language
          })
          .then(function(response) {
            console.log(response)
          })
      )
    }
  }
}
</script>
